import { createSelector } from 'reselect'
import { isEmpty, emptyArr } from 'util/arrays'
import { selectCurrentChannelAccessList } from 'selectors/access_list'

// NOTE (jscheel): Private copy because circ deps are killing us
// eslint-disable-next-line no-underscore-dangle
const _selectGroups = state => state.groups || emptyArr

export const selectGroupsFilteredByCurrentChannelAccessList = createSelector(
  _selectGroups,
  selectCurrentChannelAccessList,
  (groups, accessList) => {
    if (!accessList || !accessList.groupIds || isEmpty(accessList.groupIds)) {
      return groups
    }
    const lookup = new Set(accessList.groupIds)
    return groups.filter(group => lookup.has(group.id))
  }
)

export const selectGroupsFilteredByCurrentChannelAccessListById = createSelector(
  selectGroupsFilteredByCurrentChannelAccessList,
  groups => {
    return groups.reduce((memo, group) => {
      // eslint-disable-next-line no-param-reassign
      memo[group.id] = group
      return memo
    }, {})
  }
)
